import React, { Component } from "react";

import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import Grid from "@material-ui/core/Grid";
import Card from "components/Card/Card.jsx";
import CardHeader from "components/Card/CardHeader.jsx";
import FormControl from "@material-ui/core/FormControl";
import CustomInput from "components/CustomInput/CustomInput.jsx";
import Button from "components/CustomButtons/Button.jsx";
import InputLabel from "@material-ui/core/InputLabel";
import Datetime from "react-datetime";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import CustomLinearProgress from "components/CustomLinearProgress/CustomLinearProgress.jsx";
import DialogTitle from "@material-ui/core/DialogTitle";
import Typography from "@material-ui/core/Typography";
import { withStyles } from "@material-ui/core/styles";
import { pushLoader } from "../../actions/main";
import MUIDataTable from "mui-datatables";
import _ from "lodash";

import BorderColorTwoTone from "@material-ui/icons/BorderColorTwoTone";
import DeleteTwoTone from "@material-ui/icons/DeleteTwoTone";

import {
  fetchEmail,
  pushEmail,
  updateEmail,
  deleteEmail,
} from "../../api/email";

import moment from "moment";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";

const styles = (theme) => ({
  title: {
    textAlign: "center",
    flex: 1,
    fontSize: "32px",
    fontWeight: 500,
  },
});

class EmailMandatory extends Component {
  constructor(props) {
    super(props);
    this.state = {
      datatable: [],
      email: null,
      openAdd: false,
      openEdit: false,
      openDelete: false,
      id: 0,
      loader: null,
    };
  }

  componentDidMount() {
    this.getDatatable();
  }

  getDatatable = () => {
    this.props.pushLoader(true);
    this.setState({ loader: true });
    fetchEmail()
      .then((response) => {
        if (response != null) {
          this.setState({ datatable: response.data.results });
        }
        this.props.pushLoader(false);
        this.setState({ loader: false });
      })
      .catch((error) => {
        this.props.pushLoader(false);
        this.setState({ loader: false });
        console.log(error);
        this.props.history.push("/pages/login#logout");
      });
  };

  restate = (args) => {
    this.setState({
      id: args[0],
      company_code: args[1],
      title: args[2],
      description: args[3],
      dateAlert: args[4],
      openEdit: true,
    });
  };

  handleUpdate = (id) => {
    const selectedEmail = _.find(this.state.datatable, { id: id });
    this.setState({
      openEdit: true,
      email: selectedEmail.email,
      id: selectedEmail.id,
    });
  };

  updating = () => {
    updateEmail(this.state)
      .then((response) => {
        if (response != null) {
          this.getDatatable();
          this.setState({
            email: null,
            id: null,
            openEdit: false,
          });
        }
      })
      .catch((error) => {
        console.log("tidak berhasil");
        console.log(error);
        this.props.history.push("/pages/login#logout");
      });
  };

  handleDelete = (id) => {
    const selectedEmail = _.find(this.state.datatable, { id: id });
    this.setState({
      openDelete: true,
      email: selectedEmail.email,
      id: selectedEmail.id,
    });
  };

  deleting = (id) => {
    deleteEmail(this.state.id)
      .then((response) => {
        if (response != null) {
          this.getDatatable();
          this.setState({
            email: null,
            id: null,
            openDelete: false,
          });
        }
      })
      .catch((error) => {
        console.log("tidak berhasil");
        console.log(error);
        this.props.history.push("/pages/login#logout");
      });
  };

  handleClose = (key, value) => {
    this.setState({
      [key]: value,
      email: null,
    });
  };

  handleSubmit = () => {
    pushEmail(this.state)
      .then((response) => {
        if (response != null) {
          this.getDatatable();
          this.setState({
            email: null,
            openAdd: false,
          });
        }
      })
      .catch((error) => {
        console.log("tidak berhasil");
        this.props.history.push("/pages/login#logout");
      });
  };

  handleChangeText = (keys, e) => {
    this.setState({ [keys]: e.target.value });
  };

  render() {
    const { classes } = this.props;
    const columns = [
      {
        name: "id",
        label: "id",
        options: {
          filter: false,
          display: false,
        },
      },
      {
        name: "email",
        label: "Email",
        options: {
          filter: true,
          display: true,
          align: "center",
        },
      },
      {
        name: "id",
        label: "Update",
        options: {
          filter: true,
          sort: false,
          customBodyRender: (value, tableMeta, updateValue) => {
            return (
              <BorderColorTwoTone
                color="primary"
                onClick={(event) => this.handleUpdate(value)}
                style={{ cursor: "pointer" }}
              />
            );
          },
        },
      },
      {
        name: "id",
        label: "Delete",
        options: {
          filter: true,
          sort: false,
          customBodyRender: (value, tableMeta, updateValue) => {
            return (
              <DeleteTwoTone
                color="primary"
                onClick={(event) => this.handleDelete(value)}
                style={{ cursor: "pointer" }}
              />
            );
          },
        },
      },
    ];

    const options = {
      filter: false,
      //filterType: "dropdown",
      selectableRows: false,
      responsive: "scroll",
      textLabels: {
        body: {
          noMatch: this.props.loader
            ? "Searching..."
            : "Sorry, no matching records found",
        },
      },
    };
    return (
      <GridContainer>
        <GridItem xs={12} sm={12} md={12}>
          <div style={{ justifyContent: "center" }}>
            <Typography className={classes.title}>Email Mandatory</Typography>
            <CustomLinearProgress
              variant="determinate"
              color="gray"
              value={0}
              style={{ width: "40%", display: "inline-block" }}
            />
            <CustomLinearProgress
              variant="determinate"
              color="info"
              value={100}
              style={{ width: "20%", display: "inline-block" }}
            />
            <CustomLinearProgress
              variant="determinate"
              color="gray"
              value={0}
              style={{ width: "40%", display: "inline-block" }}
            />
          </div>
        </GridItem>
        <Grid item xs={12}>
          <Grid container justify="center" spacing={2}>
            <GridItem xs={10} sm={10} md={10}>
              <Card>
                <CardHeader color="rose" icon>
                  <Button
                    color="success"
                    round
                    disable={!this.state.loader}
                    onClick={() => this.handleClose("openAdd", true)}
                  >
                    Add Email
                  </Button>
                </CardHeader>
                <MUIDataTable
                  data={this.state.datatable}
                  options={options}
                  columns={columns}
                />
              </Card>
              <Dialog
                open={this.state.openAdd}
                onClose={() => this.handleClose("openAdd", false)}
                aria-labelledby="form-dialog-title"
                maxWidth="md"
                fullWidth={true}
              >
                <DialogTitle id="form-dialog-title">Add Email</DialogTitle>
                <DialogContent>
                  <GridContainer>
                    <GridItem xs={12} sm={12} md={12}>
                      <CustomInput
                        labelText="Email"
                        id="email"
                        inputProps={{
                          value: this.state.email,
                          onChange: (e) => this.handleChangeText("email", e),
                        }}
                        formControlProps={{
                          fullWidth: true,
                        }}
                      />
                    </GridItem>
                  </GridContainer>
                </DialogContent>
                <DialogActions>
                  <Button
                    onClick={() => this.handleClose("openAdd", false)}
                    color="default"
                    round
                    disable={!this.state.loader}
                  >
                    Cancel
                  </Button>
                  <Button
                    onClick={() => this.handleSubmit()}
                    color="success"
                    round
                    disable={!this.state.loader}
                  >
                    Save
                  </Button>
                </DialogActions>
              </Dialog>
              <Dialog
                open={this.state.openEdit}
                onClose={() => this.handleClose("openEdit", false)}
                aria-labelledby="form-dialog-title"
                maxWidth="md"
                fullWidth={true}
              >
                <DialogTitle id="form-dialog-title">Update Email</DialogTitle>
                <DialogContent>
                  <GridContainer>
                    <GridItem xs={12} sm={12} md={12}>
                      <CustomInput
                        labelText="Email"
                        id="email"
                        inputProps={{
                          value: this.state.email,
                          onChange: (e) => this.handleChangeText("email", e),
                        }}
                        formControlProps={{
                          fullWidth: true,
                        }}
                      />
                    </GridItem>
                  </GridContainer>
                </DialogContent>
                <DialogActions>
                  <Button
                    onClick={() => this.handleClose("openEdit", false)}
                    color="default"
                    disable={!this.state.loader}
                    round
                  >
                    Cancel
                  </Button>
                  <Button
                    onClick={() => this.updating()}
                    color="success"
                    round
                    disable={!this.state.loader}
                  >
                    Update
                  </Button>
                </DialogActions>
              </Dialog>
              <Dialog
                open={this.state.openDelete}
                onClose={() => this.handleClose("openDelete", false)}
                aria-labelledby="form-dialog-title"
                maxWidth="md"
                fullWidth={true}
              >
                <DialogTitle id="form-dialog-title">Delete Email</DialogTitle>
                <DialogContent>
                  <GridContainer>
                    <GridItem xs={12} sm={12} md={12}>
                      <h3>Do you really want to delete {this.state.email}?</h3>
                    </GridItem>
                  </GridContainer>
                </DialogContent>
                <DialogActions>
                  <Button
                    onClick={() => this.handleClose("openDelete", false)}
                    color="default"
                    round
                    disable={!this.state.loader}
                  >
                    Cancel
                  </Button>
                  <Button
                    onClick={() => this.deleting()}
                    color="success"
                    round
                    disable={!this.state.loader}
                  >
                    Delete
                  </Button>
                </DialogActions>
              </Dialog>
            </GridItem>
          </Grid>
        </Grid>
      </GridContainer>
    );
  }
}

function mapStateToProps(state) {
  return {};
}

export default withRouter(connect(
  mapStateToProps,
  { pushLoader }
)(withStyles(styles)(EmailMandatory)));
